import { createUseStyles } from 'react-jss';
import { colors } from '../../../styles';

export const logoStyles = createUseStyles({
  logo: {
    fill: colors.primary,
  },
});
